import TextField from '@mui/material/TextField';

export default function PollTextField({label, placeholder, ...otherProps}) {
  return <>
    <TextField id="outlined-basic" label={label} variant="outlined" placeholder={placeholder} {...otherProps}/>
  </>
}
